import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import { useLanguage } from "@/lib/i18n";
import { blogContent } from "./content";

export function BlogHero() {
  const { language, getLocalizedPath } = useLanguage();
  const c = blogContent[language].hero;

  return (
    <header className="relative pt-28 pb-8 md:pt-32 md:pb-10">
      <div className="mx-auto max-w-[680px] px-4 sm:px-6">
        <nav className="mb-8 flex items-center gap-1.5 text-xs text-muted-foreground/70">
          <Link to={getLocalizedPath("/")} className="hover:text-foreground transition-colors">
            {c.breadcrumbHome}
          </Link>
          <ChevronRight className="h-3 w-3" />
          <Link to={getLocalizedPath("/blog")} className="hover:text-foreground transition-colors">
            {c.breadcrumbBlog}
          </Link>
          <ChevronRight className="h-3 w-3" />
          <span className="text-foreground/60">{c.breadcrumbCategory}</span>
        </nav>

        <div className="mb-5">
          <span className="text-xs font-bold uppercase tracking-[0.15em] text-primary">
            {c.categoryTag}
          </span>
        </div>

        <h1 className="font-['Source_Serif_4'] text-[2rem] sm:text-[2.5rem] md:text-[3rem] leading-[1.15] tracking-tight text-foreground font-semibold mb-6">
          {c.title}
        </h1>

        <p className="font-['Source_Serif_4'] text-lg sm:text-xl leading-relaxed text-muted-foreground italic mb-10">
          {c.subtitle}
        </p>

        <div className="flex items-center gap-3 pb-8 border-b border-border/30">
          <div className="flex h-10 w-10 items-center justify-center rounded-full bg-primary/15 text-primary font-bold text-sm font-['Funnel_Display']">
            R
          </div>
          <div className="flex flex-col">
            <span className="text-sm font-semibold text-foreground">{c.author}</span>
            <div className="flex items-center gap-2 text-xs text-muted-foreground">
              <time>{c.date}</time>
              <span>·</span>
              <span>{c.readingTime}</span>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
}
